import React, { useState, useEffect } from "react";

const AUTOPLAY_MS = 3500;

export const Testimonials = (props) => {
  const items = props.data || [];
  const count = items.length;
  const [active, setActive] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    const reduceMotion =
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (paused || count < 2 || reduceMotion) return undefined;
    const timer = setInterval(
      () => setActive((current) => (current + 1) % count),
      AUTOPLAY_MS
    );
    return () => clearInterval(timer);
  }, [paused, count]);

  const go = (step) => setActive((current) => (current + step + count) % count);

  // Signed circular distance of a card from the active (center) card
  const offsetOf = (index) => {
    let d = (index - active + count) % count;
    if (d > count / 2) d -= count;
    return d;
  };

  return (
    <section id="testimonials">
      <div className="container">
        <div className="section-title text-center">
          <span className="section-kicker">KIND WORDS</span>
          <h2>What our clients say</h2>
        </div>
        {count > 0 ? (
          <div
            className="testimonial-carousel"
            onMouseEnter={() => setPaused(true)}
            onMouseLeave={() => setPaused(false)}
            onFocus={() => setPaused(true)}
            onBlur={() => setPaused(false)}
          >
            <div className="testimonial-stage">
              {items.map((d, i) => {
                const offset = offsetOf(i);
                const distance = Math.abs(offset);
                const isActive = offset === 0;
                return (
                  <div
                    key={`${d.name}-${i}`}
                    className={`testimonial-slide${isActive ? " is-active" : ""}`}
                    aria-hidden={!isActive}
                    style={{
                      transform: `translateX(calc(-50% + ${offset * 108}%)) scale(${isActive ? 1 : 0.82})`,
                      opacity: distance === 0 ? 1 : distance === 1 ? 0.55 : 0,
                      zIndex: 10 - distance,
                    }}
                  >
                    <div className="testimonial">
                      <span className="quote-mark" aria-hidden="true">“</span>
                      <div className="testimonial-image">
                        <img src={d.img} alt="" />
                      </div>
                      <div className="testimonial-content">
                        <p>{d.text}</p>
                        <div className="testimonial-meta">{d.name}</div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="testimonial-controls">
              <button
                type="button"
                className="testimonial-arrow"
                onClick={() => go(-1)}
                aria-label="Previous testimonial"
              >
                <i className="fa fa-angle-left" aria-hidden="true"></i>
              </button>
              <div className="testimonial-dots">
                {items.map((d, i) => (
                  <button
                    key={`dot-${d.name}-${i}`}
                    type="button"
                    className={i === active ? "is-active" : ""}
                    onClick={() => setActive(i)}
                    aria-label={`Show testimonial from ${d.name}`}
                  ></button>
                ))}
              </div>
              <button
                type="button"
                className="testimonial-arrow"
                onClick={() => go(1)}
                aria-label="Next testimonial"
              >
                <i className="fa fa-angle-right" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        ) : (
          "loading"
        )}
      </div>
    </section>
  );
};
